import React from 'react';

export const PowerIntelligenceSection: React.FC = () => {
  return (
    <section
      className="spaq-intelligence py-20 sm:py-24 lg:py-28 bg-[#FFFFFF] text-[#122331]"
      aria-labelledby="spaq-intelligence-heading"
    >
      <div className="max-w-[1280px] mx-auto px-5 sm:px-8 lg:px-12">
        {/* Top Two-Column Grid: Left Lead, Right Narrative */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          {/* Left Column (~45%) */}
          <div className="lg:col-span-5 space-y-4">
            <span className="block text-xs font-bold tracking-[0.2em] text-[#526372] uppercase">
              POWER INTELLIGENCE
            </span>
            <h2
              id="spaq-intelligence-heading"
              className="text-[clamp(44px,7.5vw,96px)] font-bold tracking-tight text-[#122331] leading-[1.14]"
            >
              電力に、<br />
              知性を。
            </h2>
          </div>

          {/* Right Column (~55%) */}
          <div className="lg:col-span-7 lg:pt-8 space-y-6">
            <h3 className="text-[clamp(24px,3.2vw,38px)] font-bold text-[#122331] leading-snug">
              電力を読み解き、最適な設計と制御へ。
            </h3>
            <p className="text-base sm:text-lg text-[#526372] leading-[1.8] max-w-2xl">
              施設ごとに異なる電気の使い方を捉え、<br className="hidden sm:inline" />
              導入判断から日々の運用までをつなぐ。
            </p>
          </div>
        </div>

        {/* Bottom 3-Role Grid */}
        <div className="mt-16 sm:mt-20 pt-12 border-t border-[#DCE4EA]">
          <ul className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 list-none p-0 m-0">
            {[
              {
                num: '01',
                title: '読み解く',
                desc: '需要と経済性を捉える',
              },
              {
                num: '02',
                title: '設計する',
                desc: '設備の組み合わせを考える',
              },
              {
                num: '03',
                title: '制御する',
                desc: '現場の動きを最適化する',
              },
            ].map((item) => (
              <li
                key={item.num}
                className="flex flex-col border-l-2 border-[#DCE4EA] pl-5 sm:pl-6 space-y-2"
              >
                <span className="font-mono text-xs sm:text-sm font-semibold text-[#526372]">
                  {item.num}
                </span>
                <h4 className="text-2xl sm:text-[28px] font-bold text-[#122331] tracking-tight">
                  {item.title}
                </h4>
                <p className="text-sm sm:text-base text-[#526372] leading-relaxed">
                  {item.desc}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
